// extracted by mini-css-extract-plugin
export default {"external":"aM9Kh1","tag":"bM9Kh1","text":"cM9Kh1","block":"dM9Kh1"};